import { produceAxios1, getAction, deleteAction, putAction, postAction, httpAction, fromDataPostAction, fromDataPostActionMultipart } from '@/api/manage'
// import { produceAxios } from
// 字典值
export const getDictModel = (params) => getAction("/sys/dict/getDictModel", params)
// 仓库类型
export const wmsWarehouseGetTypeList = (params) => getAction("/wms/wmsWarehouse/getTypeList", params)
// 仓库下拉(包含审批失败)
export const wmsWarehouseQueryList = (params) => getAction("/wms/wmsWarehouse/queryListAll", params)
// 仓库下拉(不含审批失败)
export const WarehouseQueryList = (params) => getAction("/wms/wmsWarehouse/queryList", params)
// 分类树
export const categoryGetTree = (params) => getAction('/sys/category/getTree', params)
// 盘点状态
export const wmsWarehouseInventoryGetStatusList = (params) => getAction('/wms/wmsWarehouseInventory/getStatusList', params)
// 执行详情
export const messNotQualityHandleIinfoDetailQueryInfoById = (params) => getAction(`/mess/messNotQualityHandleIinfoDetail/queryInfoById?id=${params}`)
// 确认接收
export const messNotQualityHandleIinfoDetailExecuteCompromise = (params) => postAction('/mess/messNotQualityHandleIinfoDetail/executeCompromise', params)
// 仓库列表，以仓库分类分为多个集合
export const wmsWarehouseGetWmsWaterhouse = (params) => getAction('/wms/wmsWarehouse/getWmsWaterhouse', params)
// 返修工序下拉
export const getFullProcessByOrderId = (params) => getAction("/mess/messProductOrderTask/getFullProcessByOrderId", params)
// 发起返修
export const messNotQualityHandleIinfoDetailExecuteRepair = (params) => postAction("/mess/messNotQualityHandleIinfoDetail/executeRepair", params)
// 报废入库
export const messNotQualityHandleIinfoDetailExecuteScrap = (params) => postAction("/mess/messNotQualityHandleIinfoDetail/executeScrap", params); // 执行报废
// 合格品清单
export const qualifiedList = (params) => getAction('/mess/messQualifiedList/list', params)
// 申请入库
export const qualifiedListApplyInBound = (params) => postAction('/mess/messQualifiedList/applyInBound', params)
// 不合格品处理
export const messNotQualityHandleIinfoHandle = (params) => postAction("/mess/messNotQualityHandleIinfo/handle", params);
// 库存详情
export const wmsWarehouseQueryByGoodsId = (params) => getAction('/wms/wmsWarehouse/queryByGoodsId', params)
// 附件详情
export const pubAttachmentFile = (params) => getAction('/public/pubAttachmentFile/queryById', params)
// 新建水位
export const wmsGoodsWaterLevelAdd = (params) => postAction('/wms/wmsGoodsWaterLevel/add', params)
// 编辑水位
export const wmsGoodsWaterLevelEdit = (params) => putAction('/wms/wmsGoodsWaterLevel/edit', params)
// 设备列表
export const pageQueryDeviceEntity = (params) => getAction('/mess/device/pageQueryDeviceEntity', params)
// 项目列表
export const messDeviceMaintainItemList = (params) => getAction('/mess/messDeviceMaintainItem/list', params)
// 保养任务详情
export const messDeviceMaintainTaskqueryById = (params) => getAction('/mess/messDeviceMaintainTask/queryById', params)
// 新建保养任务
export const messDeviceMaintainTaskAdd = (params) => postAction('/mess/messDeviceMaintainTask/add', params)
// 保养任务汇报
export const messDeviceMaintainTaskReport = (params) => postAction('/mess/messDeviceMaintainTask/report', params)
// 维修任务退回
export const sendback = (params) => postAction('/assetmgt/messDeviceRepair/sendback', params)
//故障报修表-用户最新维修信息
export const reportNewRepairInfo = (data) => postAction("/assetmgt/messDeviceRepair/reportNewRepairInfo", data)
//故障报修表-汇报
export const repairReport = (data) => postAction("/assetmgt/messDeviceRepair/report", data)
//故障报修表-通过id查询详情
export const queryInfoById = (params) => getAction("/assetmgt/messDeviceRepair/queryInfoById", params)
//常用应用查询
export const commonlyList = (params) => getAction("/commonly/app/queryList", params)
//申请表单菜单列表
export const commonlyQueryApplyForm = (params) => produceAxios1("/mgt/mgtApplyForm/queryApplyForm", params)
//常用应用保存
export const commonlyAppSave = (params) => postAction("/commonly/app/save", params)
//报表菜单列表
export const getMenuTreeByPIds = (params) => getAction("/sys/permission/getReportList", params)
//设备详情
export const messDeviceQueryById = (params) => getAction("/mess/device/queryById", params)
//设备详情
export const shopPurchaseSubmit = (params) => postAction("purchasemgt/erpPurchaseTaskApply/shopPurchaseSubmit", params)

  //获取不合格数
  export const getUnqualifiedReasonList2 = (params) =>
  getAction("unqualifieditems/qualityUnqualifiedItems/getList", params);

  // 工序信息全部
export const queryProcess = (params) =>
getAction("/baseSetting/process/list", params);
export const queryProcesslist = (params) =>
getAction("/management/outsourcing/queryOutsourcing", params);